import { gql } from '@apollo/client';

export default gql`
  query previewPageData($key: String, $pageId: String) {
    previewPageData(key: $key, pageId: $pageId)
  }
`; 